module.exports = {"sideMenu":{"show_channels_without_vector":true,"icons":{"steam":"wind","EE":"bolt","gas":"burn","fluidth":"star-of-life","olioc":"tint","t":"star-of-life","GPL":"star-of-life","Diesel":"star-of-life","CDR":"star-of-life","spll":"star-of-life","benz":"star-of-life","parameters":"star-of-life","default":"star-of-life","water":"faucet"}}}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = DEN3
// module chunks = 4